export const addCommentLabel = "Add Comment";
export const emptyString = "";
export const textAreaPlaceholder = "Enter your comment or reply here";
export const replyLater = "Reply Later";
export const replyNow = "Reply Now";
export const showReplies = "Show Replies";
export const hideReplies = "Hide Replies";
export const replyButtonLabel = "Reply Here";